export const expectedPaymentHeaders = [
    'marketplace',
    'transaction_type',
    'invoice_id',
    'payment_number',
    'payment_amount',
    'payment_currency',
    'payment_date',
];

export const allowedMarketplaces = [
    'vivid seats',
    'automatiq b2b',
    'seat geek',
    'fanxchange',
    'gametime',
    'stubhub',
    'ticket evolution',
    'ticketmaster',
    'ticket monster',
    'ticketnetwork',
    'ticketnetwork mercury',
    'tickpick',
    'viagogo',
    'other',
];

export const allowedTransactionTypes = ['payment', 'credit', 'adjustment'];

export const expectedInvoiceHeaders = [
    'customer',
    'invoice_id',
    'amount',
    'currency',
    'date',
    'external_reference',
    'performer',
    'event_date',
    'status',
    'fullfilment',
];

export const allowedStatuses = ['unpaid', 'paid', 'partially paid'];

export const allowedFullfilment = ['complete', 'pending'];
